import React, {useEffect} from 'react';
import Chart from './Chart';
import merge from 'lodash/merge'

export default function ColumnChart(props) {

  const defaultColumnOptions = {
    chart: {
      type: 'column'
    },
    yAxis: {
      min: 0,
      title: {
        text: ''
      },
      labels: {
        format: '{value}' + '%' || '%'
      },
      plotLines: [{
        value: 0,
        width: 1,
        color: '#808080'
      }]
    },
    tooltip: {
      valueDecimals: 1,
      valueSuffix: '%'
    },
  }

  function serieOption(data) {
    return {
      ...merge(defaultColumnOptions, props.columnOptions),
      series: data.series,
      xAxis: {
        categories: data.categories
      }
    }
  }

  if (!props.data) {
    return <></>
  }

  return (
    <Chart
      options={serieOption(props.data)}
      legendOptions={props.legendOptions}
    />
  )
}
